<template>
  <div class="widget widget-combo" :data-field="fieldName" :id="fieldName">
    <select :class="['form-control form-control-sm', autoWidth ? 'auto-width' : '', readOnly ? 'readOnly' : '']" v-on:change="onChange" v-model="value" :disabled="!editable">
      <option v-for="(option, index) in options" :value="option" :selected="option === initialValue ? 'selected' : ''" :key="index">{{ option }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'combo-widget',

  props: {
    fieldIndex: {
      type: String,
      required: true
    },
    initialValue: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    autoWidth: {
      type: Boolean,
      default: false
    },
    model: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      value: ''
    }
  },

  mounted () {
    this.value = this.initialValue
    let that = this
    this.$on('setValue', function (val) {
      that.value = val
    })
  },

  methods: {
    onChange (e) {
      this.$parent.$emit('widgetChanged', {index: this.fieldIndex, value: this.value})
    }
  },

  beforeDestroy () {
    this.$off('setValue')
  }
}
</script>

<style lang="scss" scoped>
  select {
    pointer-events: auto;
    z-index: 1;
  }

  .readOnly {
    pointer-events: none;
  }

  .auto-width {
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/questionnaires/widgets/ComboWidget.vue